import * as React from "react";
import { useDispatch } from "react-redux";
import { AppProvider } from "@toolpad/core/AppProvider";
import { SignInPage } from "@toolpad/core/SignInPage";
import { useTheme } from "@mui/material/styles";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../config/firebaseConfig";
import { useNavigate } from "react-router-dom";

import {
  loginFailure,
  loginStart,
  loginSuccess,
  setAppUser,
  ADMIN_UIDS,
} from "./authSlice";

const providers = [
  { id: "credentials", name: "Adresse courriel et mot de passe" },
];

const Login = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const signIn = async (provider, formData) => {
    const email = formData.get("email");
    const password = formData.get("password");

    dispatch(loginStart());

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password,
      );

      const user = userCredential.user;

      dispatch(loginSuccess(user.uid));
      localStorage.setItem("userId", user.uid);

      // Fetch app_users role to determine routing.
      // role === 'gestock' → /menu (only Gestock button visible)
      // role === 'admin'   → /menu (full station list)
      // ADMIN_UIDS         → /menu
      // otherwise          → /dashboard
      let role = null;
      try {
        const snap = await getDoc(doc(db, "app_users", user.uid));
        if (snap.exists()) {
          const data = snap.data();
          role = data.role || null;
          dispatch(setAppUser(data));
        }
      } catch (e) {
        // non-blocking
      }

      const goesToMenu =
        ADMIN_UIDS.includes(user.uid) || role === "admin" || role === "gestock";
      navigate(goesToMenu ? "/menu" : "/dashboard");

      return { status: "ok", user };
    } catch (error) {
      dispatch(loginFailure(error.message));
      throw new Error("Adresse courriel ou mot de passe incorrect");
    }
  };

  return (
    <AppProvider theme={theme}>
      <SignInPage
        signIn={signIn}
        providers={providers}
        slots={{
          title: () => (
            <span style={{ fontSize: 32, fontWeight: 700 }}>Connexion</span>
          ),
          description: () => (
            <span style={{ fontSize: 18, color: "#555" }}>
              Veuillez vous connecter pour accéder à votre espace personnel.
            </span>
          ),
          rememberMe: () => null, // supprime "Remember me"
          welcome: () => null, // supprime "Welcome user ..."
          header: () => null, // supprime header si utilisé
          submitButton: (props) => (
            <button
              {...props}
              type="submit"
              style={{
                width: "100%",
                padding: "10px",
                background: "#1976d2",
                color: "white",
                border: "none",
                borderRadius: 4,
                fontSize: 16,
                fontWeight: 600,
                cursor: "pointer",
                marginTop: 16,
              }}
            >
              Se connecter
            </button>
          ),
        }}
        slotProps={{
          emailField: {
            label: "Adresse courriel",
            placeholder: "Entrez votre adresse courriel",
          },
          passwordField: {
            label: "Mot de passe",
            placeholder: "Entrez votre mot de passe",
          },
        }}
      />
    </AppProvider>
  );
};

export default Login;
